import React, { Component } from "react";
import "./profile.css";

class Profile extends Component {
  state = {};
  render() {
    return (
      <div className="Rectangle-4">
        <div className="row profRow1">
          <div className="col-5 padd">
            <div className="Oval m-auto" />
          </div>
          <div className="col padd">
            <h1 className="profile-text">Profile Overview</h1>
          </div>
        </div>

        <div className="row profRow">
          <div className="col-5 padd">
            <div className="Oval-Copy m-auto" />
          </div>
          <div className="col padd">
            <h1 className="profile-text1">My Portfolio</h1>
          </div>
        </div>
        <div className="row profRow">
          <div className="col-5 padd">
            <div className="Oval-Copy m-auto" />
          </div>
          <div className="col padd">
            <h1 className="profile-text1">Trading History</h1>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
